<script lang="ts">
    import {getLocalization} from 'src/core';
    import type {Message} from 'src/typings';
    import type {PaginationData} from '../../search-manager/pagination';
    import KpSearchResultGenericTable from '../KpSearchResultGenericTable.svelte';
    import KpSearchItemMessageRow from './KpSearchItemMessageRow.svelte';

    export let messagesPaginationData: PaginationData<Message>;

    const localize = getLocalization();
</script>

<KpSearchResultGenericTable fixedLayout>
    <tr slot="header">
        <th class="header-target">{localize(/* @kp-localization message.TargetUser */ 'message.TargetUser')}</th>
        <th class="header-created">{localize(/* @kp-localization message.DateCreated */ 'message.DateCreated')}</th>
        <th class="header-topic">{localize(/* @kp-localization message.Topic */ 'message.Topic')}</th>
        <th class="header-severity">{localize(/* @kp-localization message.Severity */ 'message.Severity')}</th>
        <th class="header-more">{localize(/* @kp-localization commons.Options */ 'commons.Options')}</th>
    </tr>

    <svelte:fragment slot="body">
        {#each messagesPaginationData.items as message(message.id)}
            <KpSearchItemMessageRow {message}/>
        {/each}
    </svelte:fragment>
</KpSearchResultGenericTable>